import { FormattedMessage } from "react-intl";

const CocoHeader = () => {
  return (
    <div className="cococonfig__lists-header row border-bottom py-2">
      <div className="col-sm-4">
        <h6>
          {" "}
          <FormattedMessage
            id="cococonfig.Configuration"
            defaultMessage="Configuration"
          />
        </h6>
      </div>
      <div className="col-sm-8">
        <h6>
          {" "}
          <FormattedMessage id="cococonfig.Value" defaultMessage="Value" />
        </h6>
      </div>
    </div>
  );
};

export default CocoHeader;
